import { DOCUMENT } from '@angular/common';
import { Directive, inject } from '@angular/core';
import { ScrollSectionDirective } from './scroll-section.directive';

@Directive({
  standalone: true,
  selector: '[appScrollManager]'
})
export class ScrollManagerDirective {
  private readonly document = inject(DOCUMENT);
  private sections = new Map<string | number, ScrollSectionDirective>();

  scroll(id: string | number): void {
    const section = this.sections.get(id) ?? this.sections.get(String(id));
    if (section) {
      section.scroll();
      return;
    }

    const normalizedId = String(id);
    const fallbackTarget =
      this.document.getElementById(normalizedId) ??
      this.document.querySelector<HTMLElement>(
        `[data-scroll-section="${CSS.escape(normalizedId)}"], [data-scroll-section~="${CSS.escape(normalizedId)}"]`
      );

    fallbackTarget?.scrollIntoView({
      behavior: 'smooth'
    });
  }

  register(section: ScrollSectionDirective): void {
    this.sections.set(section.id, section);
  }

  remove(section: ScrollSectionDirective): void {
    this.sections.delete(section.id);
  }
}
